import { create } from "zustand";

export interface OnlineUserEntry {
    username: string;
    currentPage: string;
    lastUpdated: string;
}

export interface IncomingMessage {
    from: string;
    message: string;
    sentAt: string;
}

interface OnlineUsersStore {
    onlineUsers: OnlineUserEntry[];
    incomingMessage: IncomingMessage | null;
    setOnlineUsers: (users: OnlineUserEntry[]) => void;
    setIncomingMessage: (msg: IncomingMessage) => void;
    clearIncomingMessage: () => void;
}

export const useOnlineUsersStore = create<OnlineUsersStore>()((set) => ({
    onlineUsers: [],
    incomingMessage: null,
    setOnlineUsers: (incoming) =>
        set((state) => {
            const existingMap = new Map(state.onlineUsers.map((u) => [u.username, u]));
            const hasChanges =
                existingMap.size !== incoming.length ||
                incoming.some(
                    (u) =>
                        existingMap.get(u.username)?.currentPage !== u.currentPage ||
                        existingMap.get(u.username)?.lastUpdated !== u.lastUpdated
                );
            if (!hasChanges) return state;
            const merged = incoming.map((u) => {
                const existing = existingMap.get(u.username);
                if (existing && existing.currentPage === u.currentPage && existing.lastUpdated === u.lastUpdated)
                    return existing;
                return u;
            });
            return { onlineUsers: merged };
        }),
    setIncomingMessage: (msg) => set({ incomingMessage: msg }),
    clearIncomingMessage: () => set({ incomingMessage: null }),
}));